import { render, staticRenderFns } from "./FormGender.vue?vue&type=template&id=61ceadb6"
import script from "./FormGender.vue?vue&type=script&lang=js"
export * from "./FormGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports